import React from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen card-container text-white">
      <div className="text-center p-8 bg-neo-card flex flex-col items-center gap-4">
        <Icon icon="tabler:error-404" className="text-8xl text-primary" />
        <h1 className="text-4xl font-bold">404 - Page Not Found</h1>
        <p className="text-lg text-font-secondary">
          Sorry, the page you are looking for does not exist or has been moved.
        </p>
        <Link
          to="/"
          className="flex flex-row items-center justify-center gap-2 p-3 button-container w-fit"
        >
          <Icon icon="material-symbols:home-outline" className="text-2xl text-primary" />
          Go to Login
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;